/* /pages/kontakt – „Kontakt & Anfahrt“ (snippets/cm-x-kontakt.liquid).
   1. Live-Anzeige: rechnet aus den regulären Öffnungszeiten des Themes (data-hours, Montag … Sonntag, Minuten seit
      Mitternacht) und der Uhrzeit in Friedrichshafen (Europe/Berlin), ob regulär geöffnet ist. Feiertage kennt das Theme
      nicht – deshalb heißt es überall „regulär“. Fehlen die Zeiten oder kann der Browser die Zeitzone nicht, bleibt die
      Seite, wie sie ohne Skript ist (Öffnungszeiten als Text, Wochenleiste ohne „heute“).
   2. Himmel über dem Schaufenster: Tag, Dämmerung oder Nacht nach dem Sonnenstand über Friedrichshafen (nur Schmuck).
   3. Lagekarte: „Näher ran“ / „Übersicht“.
   Das Anfrageformular bedient weiter assets/cm-contact.js; hier wird es nicht angefasst.
   Zum Ansehen anderer Zeiten: ?xk-zeit=2026-10-03T08:30 (Uhrzeit in Friedrichshafen) an die Adresse hängen. */
(() => {
  const init = () => {
    const root = document.querySelector('[data-cm-x-kontakt]');
    if (!root || root.dataset.xkReady) return;
    root.dataset.xkReady = '1';
    const stage = root.querySelector('[data-xk-stage]');
    let T = {};
    try { T = JSON.parse(root.querySelector('[data-xk-texts]').textContent); } catch (e) { T = {}; }
    const en = root.dataset.lang === 'en';

    /* ── Karte ── */
    const map = root.querySelector('[data-xk-map]');
    const zoom = root.querySelector('[data-xk-zoom]');
    if (map && zoom) {
      zoom.hidden = false;
      zoom.addEventListener('click', () => {
        const near = map.dataset.zoom !== 'near';
        map.dataset.zoom = near ? 'near' : 'far';
        zoom.setAttribute('aria-pressed', near ? 'true' : 'false');
        const label = zoom.querySelector('[data-xk-zoom-text]');
        if (label && T.zoomIn) label.textContent = near ? T.zoomOut : T.zoomIn;
      });
    }

    /* ── Uhrzeit in Friedrichshafen ── */
    let fmt;
    try {
      fmt = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Berlin', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
      fmt.formatToParts(new Date());
    } catch (e) { return; }
    const wall = (date) => {
      const p = {};
      fmt.formatToParts(date).forEach((x) => { p[x.type] = x.value; });
      const asUtc = Date.UTC(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute);
      return { y: +p.year, mo: +p.month, d: +p.day, min: (+p.hour % 24) * 60 + +p.minute, wd: (new Date(asUtc).getUTCDay() + 6) % 7, asUtc };
    };
    // Testzeit aus der Adresse (Ortszeit Friedrichshafen) → echter Zeitpunkt
    let fixed = null;
    const m = /[?&]xk-zeit=(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})/.exec(location.search);
    if (m) {
      const want = Date.UTC(+m[1], +m[2] - 1, +m[3], +m[4], +m[5]);
      let guess = want - 3600000;
      for (let i = 0; i < 3; i++) guess += want - wall(new Date(guess)).asUtc;
      fixed = new Date(guess);
    }
    const now = () => fixed || new Date();

    /* ── Himmel ── */
    const sky = () => {
      const date = now();
      const w = wall(date);
      const doy = Math.round((Date.UTC(w.y, w.mo - 1, w.d) - Date.UTC(w.y, 0, 0)) / 86400000);
      const rad = Math.PI / 180;
      const decl = -23.44 * Math.cos(2 * Math.PI * (doy + 10) / 365) * rad;
      const lat = 47.65 * rad;
      const utcH = date.getUTCHours() + date.getUTCMinutes() / 60;
      let ha = ((utcH + 9.48 / 15 - 12) * 15) % 360;
      if (ha > 180) ha -= 360;
      if (ha < -180) ha += 360;
      const el = Math.asin(Math.sin(lat) * Math.sin(decl) + Math.cos(lat) * Math.cos(decl) * Math.cos(ha * rad)) / rad;
      const state = el > 6 ? 'day' : el > -7 ? (ha < 0 ? 'dawn' : 'dusk') : 'night';
      const haMax = Math.acos(Math.max(-1, Math.min(1, -Math.tan(lat) * Math.tan(decl)))) / rad;
      const prog = Math.max(0, Math.min(1, (ha + haMax) / (2 * haMax)));
      stage.dataset.sky = state;
      stage.style.setProperty('--xk-sx', (57 + prog * 20).toFixed(1) + '%'); // rechts von der Überschrift, links von der Anzeige
      stage.style.setProperty('--xk-sy', (7 + (1 - Math.sin(Math.PI * prog)) * 38).toFixed(1) + '%');
    };

    /* ── Regulär geöffnet? ── */
    const week = (root.dataset.hours || '').split('|').map((s) => { const p = /^(\d+)-(\d+)$/.exec(s); return p ? [+p[1], +p[2]] : null; });
    const hoursOk = week.length === 7 && week.some(Boolean) && T.open && T.day;
    const clock = (min) => {
      const h = Math.floor(min / 60), mm = min % 60;
      if (!en) return mm ? `${h}:${String(mm).padStart(2, '0')} Uhr` : `${h} Uhr`;
      const h12 = h % 12 || 12, ap = h < 12 ? 'am' : 'pm';
      return mm ? `${h12}:${String(mm).padStart(2, '0')} ${ap}` : `${h12} ${ap}`;
    };
    const fill = (s, v) => String(s).replace('%t', v.t || '').replace('%d', v.d || '').replace('%n', v.n || '');
    const setText = (sel, text) => { root.querySelectorAll(sel).forEach((el) => { if (el.textContent !== text) el.textContent = text; }); };
    const weekEl = root.querySelector('[data-xk-week]');
    let needle = null;
    const status = () => {
      const w = wall(now());
      const slot = week[w.wd];
      let open = false, line, signTop, signMain;
      if (slot && w.min >= slot[0] && w.min < slot[1]) {
        open = true;
        const left = slot[1] - w.min;
        line = left <= 45 ? fill(T.soon, { n: left }) : fill(T.open, { t: clock(slot[1]) });
        signTop = T.signOpen; signMain = fill(T.signUntil, { t: clock(slot[1]) });
      } else if (slot && w.min < slot[0]) {
        line = fill(T.today, { t: clock(slot[0]) });
        signTop = T.signClosed; signMain = fill(T.signToday, { t: clock(slot[0]) });
      } else {
        let k = 1;
        while (k <= 7 && !week[(w.wd + k) % 7]) k++;
        const next = week[(w.wd + k) % 7], di = (w.wd + k) % 7;
        if (!next) return;
        line = k === 1 ? fill(T.tomorrow, { t: clock(next[0]) }) : fill(T.day, { d: T.daysLong[di], t: clock(next[0]) });
        signTop = T.signClosed; signMain = k === 1 ? fill(T.signTomorrow, { t: clock(next[0]) }) : fill(T.signDay, { d: T.days[di], t: clock(next[0]) });
      }
      stage.dataset.open = open ? '1' : '0';
      root.querySelectorAll('.cm-x-kontakt-hours').forEach((el) => { el.dataset.open = open ? '1' : '0'; });
      setText('[data-xk-status-text],[data-xk-status-copy]', line);
      setText('[data-xk-sign-top]', signTop);
      setText('[data-xk-sign-main]', signMain);
      const hint = root.querySelector('[data-xk-status-hint]');
      if (hint) { hint.hidden = open; if (!open) hint.textContent = T.online; }
      const note = root.querySelector('[data-xk-note]');
      if (note) note.hidden = false;
      if (weekEl) {
        const items = weekEl.children;
        for (let i = 0; i < items.length; i++) {
          const today = i === w.wd;
          items[i].classList.toggle('is-today', today);
          if (today) items[i].setAttribute('aria-current', 'date'); else items[i].removeAttribute('aria-current');
        }
        const r = /^(\d+)-(\d+)$/.exec(weekEl.dataset.range || '');
        const track = items[w.wd] && items[w.wd].querySelector('.cm-x-kontakt-week-track');
        if (r && track && w.min >= +r[1] && w.min <= +r[2]) {
          if (!needle) { needle = document.createElement('span'); needle.className = 'cm-x-kontakt-week-now'; needle.setAttribute('aria-hidden', 'true'); const lab = document.createElement('span'); lab.textContent = T.now || ''; needle.appendChild(lab); }
          if (needle.parentNode !== track) track.appendChild(needle);
          needle.style.setProperty('--xk-now', ((w.min - +r[1]) / (+r[2] - +r[1]) * 100).toFixed(2) + '%');
        } else if (needle && needle.parentNode) needle.parentNode.removeChild(needle);
      }
    };

    const tick = () => { try { sky(); if (hoursOk) status(); } catch (e) { /* Seite bleibt, wie sie ohne Skript ist */ } };
    tick();
    root.classList.add('cm-x-kontakt-live');
    if (!fixed) {
      setInterval(tick, 30000);
      document.addEventListener('visibilitychange', () => { if (!document.hidden) tick(); });
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
